/*
 Provides Props:
 ------------------------------------
 state.catastrophe // Object
 * **catastropheType** // Object
 * msg // Short error message to display
 * raw // More detailed/technical error message for debugging

 Actions:
 --------
 state.flagCatastrophe(type, errorMsg, detailInfo)
 state.liftCatastrophe(type)

 */

export default function (state/*, widget*/) {

    // ------------------------------------------------

    state.catastrophe = {};

    // ------------------------------------------------

    state.flagCatastrophe = function (type, errorMsg, detailInfo) {
        window.console.warn(type + ':', errorMsg + ':', detailInfo);
        state.catastrophe[type] = {msg: errorMsg, raw: detailInfo};
    };
    state.liftCatastrophe = function (type) {
        delete state.catastrophe[type];
    };

}
